import React, { FC, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import NavigationItem from "./NavigationItem";
import { NAVIGATION_DEMO_2 } from "data/navigation";
import "../../styles/styles.css";
import loupe from "../../images/loupe.png";

interface Props {
  className?: string;
}

const Navigation: FC<Props> = ({ className = "flex" }) => {
  const [isRecherche, setIsRecherche] = useState(false);
  const [recherche, setRecherche] = useState("");
  const [isTablet, setIsTablet] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const navigate = useNavigate();

  // Détection tablette par largeur d'écran
  useEffect(() => {
    const checkTablet = () => setIsTablet(window.innerWidth <= 1024); // ≤1024px = tablette
    checkTablet(); // vérifie au montage
    window.addEventListener("resize", checkTablet);
    return () => window.removeEventListener("resize", checkTablet);
  }, []);

  // Filtrage des items
  const navigationItems = isTablet
    ? NAVIGATION_DEMO_2.filter((item) => item.name !== "Accueil")
    : NAVIGATION_DEMO_2;

  const rechercher = () => setIsRecherche((prev) => !prev);

  const chercher = (e: React.FormEvent) => {
    e.preventDefault();
    if (recherche.trim()) {
      navigate(`/recherche?q=${encodeURIComponent(recherche)}`);
    }
  };

  const rechercheChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRecherche(e.target.value);
  };

  useEffect(() => {
    if (isRecherche && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isRecherche]);

  return (
    <div style={{ marginLeft: "-100px" }}>
      <ul className={`nc-Navigation items-center ${className}`}>
        {navigationItems.map((item) => (
          <NavigationItem key={item.id} menuItem={item} />
        ))}

        <img src={loupe} width="20" onClick={rechercher} />

        {isRecherche && (
          <div>
            <input
              ref={inputRef}
              value={recherche}
              onChange={rechercheChange}
              style={{ width: "100px", height: "30px" }}
              type="text"
              onKeyDown={(e) => e.key === "Enter" && chercher(e)}
            />
            <button onClick={chercher} className="boutonRecherche">
              Rechercher
            </button>
          </div>
        )}
      </ul>
    </div>
  );
};

export default Navigation;
